export const ROI_CONTACT_EMAIL = 'contact@joviancloudworks.com';
export const ROI_BOOKING_URL = 'https://app.hellobonsai.com/s/joviancloudworks/discovery-call';

export const ROI_TASK_CHIPS: string[] = [
	'Data entry',
	'Status updates',
	'Reporting',
	'Scheduling',
	'Follow-ups',
	'Invoicing',
	'Reconciliation',
];

export type RoiSliderConfig = {
	min: number;
	max: number;
	step: number;
	default: number;
};

export const ROI_SLIDERS: Record<'people' | 'hours' | 'rate', RoiSliderConfig> = {
	people: { min: 1, max: 30, step: 1, default: 3 },
	hours: { min: 1, max: 40, step: 1, default: 6 },
	rate: { min: 15, max: 150, step: 5, default: 45 },
};
